import { useEffect, useRef, useState } from 'react';
import Reveal from './Reveal.jsx';
import Icon from './Icon.jsx';
import { FAQS } from '../data/site.js';

function FaqItem({ item, open, onToggle }) {
  const ref = useRef(null);
  const [, force] = useState(0);

  useEffect(() => {
    if (!open) return;
    const onResize = () => force((n) => n + 1);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [open]);

  return (
    <div className={`faq-item ${open ? 'open' : ''}`}>
      <button className="faq-q" aria-expanded={open} onClick={onToggle}>
        {item.q}
        <Icon name="chevron" size={18} width={2.2} className="faq-arrow" />
      </button>
      <div
        className="faq-a"
        ref={ref}
        style={{ maxHeight: open ? (ref.current?.scrollHeight ?? 500) : 0 }}
      >
        <p>{item.a}</p>
      </div>
    </div>
  );
}

export default function Faq() {
  const [openIdx, setOpenIdx] = useState(-1);
  return (
    <section className="faq">
      <div className="container">
        <Reveal className="section-header">
          <div className="section-label">FAQs</div>
          <h2 className="section-title">Frequently Asked Questions</h2>
          <p className="section-desc">
            Have questions about your dental care? We've answered the most common ones here.
          </p>
        </Reveal>
        <Reveal className="faq-list">
          {FAQS.map((item, i) => (
            <FaqItem
              key={item.q}
              item={item}
              open={openIdx === i}
              onToggle={() => setOpenIdx((cur) => (cur === i ? -1 : i))}
            />
          ))}
        </Reveal>
      </div>
    </section>
  );
}
